import { SellingTerminalInterface } from 'store/ducks/sellingTerminals/types';
import { TransportOperatorInterface } from '../transportOperators/types';

/*
 * Action Types
 */
export enum SellingPointsTypes {
  LIST_SELLING_POINTS_REQUEST = '@sellingPoints/LIST_SELLING_POINTS_REQUEST',
  LIST_SELLING_POINTS_SUCCESS = '@sellingPoints/LIST_SELLING_POINTS_SUCCESS',
  LIST_SELLING_POINTS_FAILURE = '@sellingPoints/LIST_SELLING_POINTS_FAILURE',

  GET_SELLING_POINT_REQUEST = '@sellingPoints/GET_SELLING_POINT_REQUEST',
  GET_SELLING_POINT_SUCCESS = '@sellingPoints/GET_SELLING_POINT_SUCCESS',
  GET_SELLING_POINT_FAILURE = '@sellingPoints/GET_SELLING_POINT_FAILURE',

  FILTER_SELLING_POINT_REQUEST = '@sellingPoints/FILTER_SELLING_POINT_REQUEST',
  FILTER_SELLING_POINT_SUCCESS = '@sellingPoints/FILTER_SELLING_POINT_SUCCESS',
  FILTER_SELLING_POINT_FAILURE = '@sellingPoints/FILTER_SELLING_POINT_FAILURE',

  CREATE_SELLING_POINT_REQUEST = '@sellingPoints/CREATE_SELLING_POINT_REQUEST',
  CREATE_SELLING_POINT_SUCCESS = '@sellingPoints/CREATE_SELLING_POINT_SUCCESS',
  CREATE_SELLING_POINT_FAILURE = '@sellingPoints/CREATE_SELLING_POINT_FAILURE',

  UPDATE_SELLING_POINT_REQUEST = '@sellingPoints/UPDATE_SELLING_POINT_REQUEST',
  UPDATE_SELLING_POINT_SUCCESS = '@sellingPoints/UPDATE_SELLING_POINT_SUCCESS',
  UPDATE_SELLING_POINT_FAILURE = '@sellingPoints/UPDATE_SELLING_POINT_FAILURE',

  DELETE_SELLING_POINT_REQUEST = '@sellingPoints/DELETE_SELLING_POINT_REQUEST',
  DELETE_SELLING_POINT_SUCCESS = '@sellingPoints/DELETE_SELLING_POINT_SUCCESS',
  DELETE_SELLING_POINT_FAILURE = '@sellingPoints/DELETE_SELLING_POINT_FAILURE',

  ADD_PAYMENT_SELLING_POINT_REQUEST = '@sellingPoints/ADD_PAYMENT_SELLING_POINT_REQUEST',
  ADD_PAYMENT_SELLING_POINT_SUCCESS = '@sellingPoints/ADD_PAYMENT_SELLING_POINT_SUCCESS',
  ADD_PAYMENT_SELLING_POINT_FAILURE = '@sellingPoints/ADD_PAYMENT_SELLING_POINT_FAILURE',

  CHANGE_SELLING_POINT_STATUS_REQUEST = '@sellingPoints/CHANGE_SELLING_POINT_STATUS_REQUEST',
  CHANGE_SELLING_POINT_STATUS_SUCCESS = '@sellingPoints/CHANGE_SELLING_POINT_STATUS_SUCCESS',
  CHANGE_SELLING_POINT_STATUS_FAILURE = '@sellingPoints/CHANGE_SELLING_POINT_STATUS_FAILURE',

  CHANGE_SELLINPOINT_PASSWORD_REQUEST = '@employees/CHANGE_SELLINPOINT_PASSWORD_REQUEST',
  CHANGE_SELLINPOINT_PASSWORD_SUCCESS = '@employees/CHANGE_SELLINPOINT_PASSWORD_SUCCESS',
  CHANGE_SELLINPOINT_PASSWORD_FAILURE = '@employees/CHANGE_SELLINPOINT_PASSWORD_FAILURE',
}

/*
 * Data types
 */
export interface SellingPointTransaction {
  id: string;
  type: number;
  amount: number;
  tokenId: string;
  createdAt: string;
  updatedAt: string;
  sellingPointId: string;
  walletChargeId: string;
  TransportOperator?: any;
  PaymentRequest?: any;
  token?: Token;
}

export interface Token {
  id: string;
  profileId?: string;
  Profile?: {
    name: string;
  };
}

export interface SellingPointPayment {
  id: string;
  amount: number;
  description: string;
  createdAt: string;
  updatedAt: string;
  supervisorId: string;
  transportOperatorId?: string | null;
  returnedPaymentId?: string | null;
}

export interface SellingPointResumeInterface {
  transactionValue: number;
  transactionCount: number;
  purchaseTransactionValue: number;
  purchaseTransactionCount: number;
  ticketTransactionValue: number;
  ticketTransactionCount: number;
  pointPaymentValue: number;
  pointPaymentCount: number;
  terminalPaymentValue: number;
  terminalPaymentCount: number;
  lastTerminalPayments: Array<SellingPointPayment>;
}

export interface SellingPointInterface {
  id: string;
  status: number;
  type: number;
  registry?: string;
  ruleType?: number;
  allowedAmount: number;
  name: string;
  document: string;
  email: string;
  phone: string;
  transactionPassword: string;
  sellingTerminalId: string;
  resume?: SellingPointResumeInterface;
  SellingTerminal?: SellingTerminalInterface;
  SellingPointTransactions?: Array<SellingPointTransaction>;
  SellingPointPayments?: Array<SellingPointPayment>;
  TransportOperators?: TransportOperatorInterface[];
  transportOperatorId: string;
  createdAt: string;
  updatedAt: string;
}

/*
 * State type
 */
export interface SellingPointsState {
  readonly sellingPointsList: SellingPointInterface[];
  readonly sellingPointData: SellingPointInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
